import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const getAlertStyling = (brand?: string): AbgSxProps => {
  const backgroundColor =
    brand === 'budget' ? paletteBase.primaryDarkBlue : paletteBase.semanticRed;

  return {
    // sx lands on Collapse; force the visible Alert paper (theme error LEVEL_1 is red)
    backgroundColor,
    position: 'relative',
    zIndex: 1201,
    '& .MuiAlert-root': {
      backgroundColor: `${backgroundColor} !important`,
    },
    '& a': {
      color: `${paletteBase.white100} !important`,
      textDecoration: 'underline !important',
      fontWeight: 700,
      '&:hover': {
        opacity: 0.85,
      },
      '&:focus-visible': {
        outline: `2px solid ${paletteBase.white100}`,
        outlineOffset: '2px',
        borderRadius: '2px',
      },
    },
    '& p': {
      margin: 0,
    },
  };
};
